// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"styles_Wrapper__OrOhr","title":"styles_title__HTtKh","subTitle":"styles_subTitle__T8DnG"};